import { Navigate } from "react-router-dom";

import { ProtectedRoute } from "@/routes/protected-route";

import { getSetupToken } from "../services/auth.service";

import { AcceptInviteTeamPage } from "./accept-invite-team.page";
import { AcceptInviteWorkspacePage } from "./accept-invite-workspace.page";
import { Forgot2FAPage } from "./forgot-2fa.page";
import { LoginPage } from "./login.page";
import { LoginSsoPage } from "./login-sso.page";
import { PasswordForgotPage } from "./password-forgot.page";
import { PasswordResetPage } from "./password-reset.page";
import { Reset2FAPage } from "./reset-2fa.page";
import { Setup2FAPage } from "./setup-2fa.page";

export const authRoutes = (isAuthenticated: boolean) => [
  { path: "/login", element: isAuthenticated ? <Navigate to="/" replace /> : <LoginPage /> },
  // Rendered whether or not a token is stored: the one-time code in the fragment is a login
  // in progress, and a session left over from another account must not swallow it.
  { path: "/login/sso", element: <LoginSsoPage /> },
  {
    // A fresh forced-2FA login (A2) reaches this page holding only a 2fa_setup
    // token — no access token — so ProtectedRoute would bounce it to /login.
    // Treat the presence of a setup token as sufficient to render the setup
    // page; otherwise fall back to the normal authenticated guard (for sessions
    // redirected here by the TwoFactorSetupGuard).
    path: "/auth/setup-2fa",
    element:
      !isAuthenticated && getSetupToken() ? (
        <Setup2FAPage />
      ) : (
        <ProtectedRoute isAuthenticated={isAuthenticated}>
          <Setup2FAPage />
        </ProtectedRoute>
      ),
  },
  {
    path: "/forgot-password",
    element: isAuthenticated ? <Navigate to="/" replace /> : <PasswordForgotPage />,
  },
  {
    path: "/reset-password",
    element: isAuthenticated ? <Navigate to="/" replace /> : <PasswordResetPage />,
  },
  {
    path: "/forgot-2fa",
    element: isAuthenticated ? <Navigate to="/" replace /> : <Forgot2FAPage />,
  },
  {
    path: "/reset-2fa",
    element: isAuthenticated ? <Navigate to="/" replace /> : <Reset2FAPage />,
  },
  // Team invitation is only for workspace members, so user needs to be authenticated
  {
    path: "/invitation/team",
    element: (
      <ProtectedRoute isAuthenticated={isAuthenticated}>
        <AcceptInviteTeamPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/invitation/workspace",
    element: <AcceptInviteWorkspacePage />,
  },
];
